import styled from "styled-components";
import { up } from 'styled-breakpoints';

const MenuHeading = styled.h3`
  font-size: 1.4em;
  font-weight: 500;

  ${up('sm')} {
    font-size: 1.5em
  }
`;

export default MenuHeading;
